import React from 'react'
import ReactDOM from 'react-dom/client'
import { Auth0Provider } from '@auth0/auth0-react'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { captureAuthErrorFromUrl } from './utils/authError'

// Snapshot any Auth0 ?error=... off the URL before React/the SDK runs, so a
// post-login denial (e.g. the email-verification gate) survives the
// origin -> '/' -> '/login' redirect bounce and LoginPage can explain it.
captureAuthErrorFromUrl()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN!}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID!}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage"
      onRedirectCallback={(appState) => {
        window.location.replace(appState?.returnTo ?? '/')
      }}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
)

reportWebVitals()

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err: unknown) => {
      console.error('Service worker registration failed:', err)
    })
  })
}
